
export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.staging.json',
    notlive: true,
    autoLoginForward: "",
    autoLoginCountdown: 0,
    serviceDownloadPath: "https://dev.asistix.com/"
};